module.exports = __webpack_public_path__ + "static/img/Seven of Pentacles.26172c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Seven of Pentacles.jpg
// module id = 1296
// module chunks = 0